import { render, staticRenderFns } from "./ResourceApprovalModalView.vue?vue&type=template&id=52b92cee"
import script from "./ResourceApprovalModalView.ts?vue&type=script&lang=ts&external"
export * from "./ResourceApprovalModalView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports